import { useMemo } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { UserAnalyticsPage } from '@/components/admin/user-analytics/user-analytics-page';
import {
  isoDay,
  resolveWindow,
} from '@/components/admin/user-analytics/window';

const isoDate = z.string().date();

// A bookmark of any type (the router JSON-parses search) falls back, not the page; optional, or zod 4 fails a link with no window.
const bookmarkedDate = z
  .unknown()
  .transform((v) => isoDate.safeParse(v).data)
  .optional();

export const searchSchema = z.object({
  start: bookmarkedDate,
  end: bookmarkedDate,
});

export const Route = createFileRoute('/_authenticated/admin/user-analytics')({
  validateSearch: searchSchema,
  staticData: { title: 'User analytics' },
  component: AdminUserAnalyticsRoute,
});

function AdminUserAnalyticsRoute(): React.ReactElement {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const { range, latest } = useMemo(() => {
    const now = new Date();
    return { range: resolveWindow(search, now), latest: isoDay(now) };
  }, [search]);

  const handleApply = (next: { start?: string; end?: string }): void => {
    void navigate({
      search: (s) => ({ ...s, start: next.start, end: next.end }),
    });
  };

  return (
    <UserAnalyticsPage
      start={range.start}
      end={range.end}
      latest={latest}
      onApply={handleApply}
    />
  );
}
